export default __webpack_public_path__ + "static/media/logo-md-480w.241a9654.webp";